/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import stringResource from 'ba-filter-nls';
import ConditionTypeOptions from './ConditionTypeOptions';

export default class SummaryHelper {
	static getSummary(condition, inverted) {
		let summary = '';
		const invertPrefix = inverted ? 'NOT( ' : '';
		const invertSuffix = inverted ? ' )' : '';

		const options = new ConditionTypeOptions();

		condition.predicates.forEach((predicate, index) => {
			// When condition.logicalOperation exists...
			//   - there are two and only two predicates
			//   - the conditionType strings in each predicate will be empty strings
			// This function is unsafe/overloaded - it should be rewritten.
			if (index === 1) {
				summary = `${summary} ${stringResource
					.get(condition.logicalOperation)
					.toLowerCase()} `;
			}
			summary = `${summary}${options.label(predicate)} '${predicate.value}'`;
		});

		// Capitalize the first letter and lower-case the rest
		return `${invertPrefix}${summary[0].toUpperCase()}${summary
			.slice(1)
			.toLowerCase()}${invertSuffix}`;
	}
}
